import * as angular from "angular";
import {IController, IQService, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../angular/models/agent.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {DataSet} from "vis-data";
import {ResourcesAlertsService} from "../../../resources/services/resources-alerts.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {LeanPlanningAlertsService} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {ScheduleType} from "../../../schedule/types/schedule.type";
import {TaskModel} from "../../../tasks/models/task.model";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {QuantitySettingType} from "../../../price-plan/types/quantitySetting.type";

export class AgentsShiftManagementTimelineNewComponent implements IController {
  agents: any;
  schedules: any;
  serviceAreas: any;
  totals: any;
  range: any;
  query: any;
  isLoading?: boolean;
  sortType?: boolean;
  isTooltipsEnabled?: boolean;
  agentsGroup: any;
  highlightedSchedules: any;
  isFavouriteAgentsMode?: boolean;
  favouriteAgentIds?: string[];
  onScheduleSelect: Function;
  onViewService: Function;
  onAxisClick: Function;
  onRightClickSchedule: Function;
  onRightClickAvailability: Function;
  onRightClickLeave: Function;
  onCreateSchedule: Function;
  onMoveGroup: Function;
  onDatesPageChange: Function;
  onAgentsGroupChange: Function;
  onToggleHighlightSchedule: Function;
  onHighlightedItemsChange: Function;
  onAgentColorClick: Function;
  onToggleIsFavouriteAgentsMode: Function;
  onToggleFavouriteAgent: Function;
  onChatClick: Function;
  onUpdateShift: Function;
  onResetFavouriteAgents: Function;
  onSort: Function;

  private container: any;
  private vis: any;
  private rrule: any;
  private options: any;
  private timeline: any;
  private topElementRef: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private readonly timeFormat: any;
  public isSuperOwner: boolean;
  private readonly shortDateFormat: any;
  private readonly longDateFormat: any;
  private timeZone: any;
  private readonly actionsByStatus: any;
  private purposeToSkillMap: any;
  private dateFormat: string[];
  private itemsDataSet: any;
  private colorPallet: any;


  ////////////////////////////// ICONS //////////////////////////////
  private iconsUrl: any;
  private $agentTypeIcon: any;
  private $emptyStarIcon: any;
  private $fullStarIcon: any;
  private $chatIcon: any;
  private readonly $branchIcon: any;
  private readonly $serviceAreaIcon: any;
  private readonly $employmentTypeIcon: any;
  private readonly $skillsIcon: any;
  private $recurringIcon: any;
  private $resourceIcon: any;
  private $routedRowIcon: any;
  private $routedWhiteIcon: any;
  public groupsViewSettings: any;
  public siteSkills: any;

  // Single delegated click handler for group-row actions, attached once on
  // `this.container` after the timeline is created. Replaces per-cell
  // `addEventListener` calls inside `groupTemplate`. The empty `chatIcon`
  // handler from the original code is intentionally not wired (its body was
  // commented out).
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;
    this._onClicked().then(() => {
      if (action === 'agent-color') {
        const group: any = this.groupsDataSet ? this.groupsDataSet.get(id) : null;
        if (group?.ref && group.agentId) {
          this.onAgentColorClick({agent: group.ref, color: this._getColorByAgentId(group.agentId)});
        }
      } else if (action === 'toggle-favourite-agent') {
        this.onToggleFavouriteAgent({agentId: id});
      } else if (action === 'view-agent-schedule') {
        const siteId = this.splitService.getSiteId();
        const url = this.$state.href('agent.agent-profile.schedule', {id: id, siteId: siteId});
        this.$window.open(url, '_blank');
      }
    });
  };

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private splitService: SplitService, private commonsService: CommonsService,
              private leanPlanningConstants, private resourcesAlertsService: ResourcesAlertsService, private leanPlanningAlertsService: LeanPlanningAlertsService,
              private commonsDialogService: CommonsDialogService, private moment, private $timeout: ITimeoutService, private bringozTimelineService: BringozTimelineService,
              private $log, private commonsConstants, private $state, private $window: IWindowService, private IAMPermissions: IAMPermissionsService) {

    this.vis = require('vis-timeline');
    this.rrule = require('rrule');

    const dateAndTimeConfig = splitService.getDateAndTimeConfig();
    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');
    this.timeFormat = dateAndTimeConfig.time;
    this.shortDateFormat = dateAndTimeConfig.date;
    this.longDateFormat = dateAndTimeConfig.long;
    this.timeZone = this.splitService.getTimeZone();
    this.purposeToSkillMap = {
      Pickup: ['Delivery'],
      Dropoff: ['Delivery'],
      Operation: ['Merchandise', 'Order']
    };
    this.dateFormat = splitService.getDateAndTimeConfig().fullDate;
    this.siteSkills = splitService.getSiteResourceSkills();

    this.iconsUrl = {
      emptyStar: 'assets/images/icons/v2/skill-outline.svg',
      fullStar: 'assets/images/icons/v2/skill.svg',
      chat: 'assets/images/icons/v2/chat.svg',
      agentType: 'assets/images/icons/v2/agent.svg',
      branch: 'assets/images/icons/v2/branch.svg',
      serviceArea: 'assets/images/icons/v2/service-area.svg',
      employmentType: 'assets/images/icons/v2/dollar-circle.svg',
      skill: 'assets/images/icons/v2/skill.svg',
      tags: 'assets/images/icons/v2/tag.svg',
      recurring: 'assets/images/icons/v2/recurring.svg',
      resource: 'assets/images/icons/v2/tiles-outline.svg',
      routed: 'assets/images/icons/v2/route.svg',
      Bicycle: 'assets/images/icons/v2/bicycle.svg',
      Motorcycle: 'assets/images/icons/v2/motorcycle.svg',
      PrivateCar: 'assets/images/icons/v2/privatecar.svg',
      Van: 'assets/images/icons/v2/van.svg',
      Truck: 'assets/images/icons/v2/truck.svg',
      Forklift: 'assets/images/icons/v2/forklift.svg',
      Trailer: 'assets/images/icons/v2/trailer.svg',
      Tractor: 'assets/images/icons/v2/tractor.svg',
      ElectricCar: 'assets/images/icons/v2/electriccar.svg',
      ElectricTruck: 'assets/images/icons/v2/electrictruck.svg',
      ElectricVan: 'assets/images/icons/v2/electricvan.svg'
    }

    this.$emptyStarIcon = document.createElement('IMG');
    this.$emptyStarIcon.setAttribute("src", this.iconsUrl.emptyStar);
    this.$emptyStarIcon.classList.add('bringoz-icon-16', 'gray');

    this.$fullStarIcon = document.createElement('IMG');
    this.$fullStarIcon.setAttribute("src", this.iconsUrl.fullStar);
    this.$fullStarIcon.classList.add('bringoz-icon-16', 'gray');

    this.$chatIcon = document.createElement('IMG');
    this.$chatIcon.setAttribute("src", this.iconsUrl.chat);
    this.$chatIcon.classList.add('bringoz-icon-16', 'gray');

    this.$agentTypeIcon = document.createElement('IMG');
    this.$agentTypeIcon.setAttribute("src", this.iconsUrl.agentType);
    this.$agentTypeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$serviceAreaIcon = document.createElement('IMG');
    this.$serviceAreaIcon.setAttribute("src", this.iconsUrl.serviceArea);
    this.$serviceAreaIcon.classList.add('bringoz-icon-small', 'gray');

    this.$branchIcon = document.createElement('IMG');
    this.$branchIcon.setAttribute("src", this.iconsUrl.branch);
    this.$branchIcon.classList.add('bringoz-icon-small', 'gray');

    this.$employmentTypeIcon = document.createElement('IMG');
    this.$employmentTypeIcon.setAttribute("src", this.iconsUrl.employmentType);
    this.$employmentTypeIcon.classList.add('bringoz-icon-small', 'gray');


    this.$skillsIcon = document.createElement('IMG');
    this.$skillsIcon.setAttribute("src", this.iconsUrl.skill);
    this.$skillsIcon.classList.add('bringoz-icon-small', 'gray');


    this.$recurringIcon = document.createElement('IMG');
    this.$recurringIcon.setAttribute("src", this.iconsUrl.recurring);
    this.$recurringIcon.classList.add('bringoz-icon-small', 'white');


    this.$resourceIcon = document.createElement('IMG');
    this.$resourceIcon.setAttribute("src", this.iconsUrl.resource);
    this.$resourceIcon.classList.add('bringoz-icon-small');


    this.$routedRowIcon = document.createElement('IMG');
    this.$routedRowIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedRowIcon.classList.add('bringoz-icon-small', 'gray');


    this.$routedWhiteIcon = document.createElement('IMG');
    this.$routedWhiteIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedWhiteIcon.classList.add('bringoz-icon-small', 'white');
  }

  $onInit() {

    this.groupsViewSettings = {
      // employmentType: true,
      // skills: true,
      // vehicleType: true,
      tags: true,
      serviceAreas: true,
      branches: true
    }

    this.colorPallet = this.commonsConstants.colorPalletTwo;

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet();
    this.itemsDataSet = new DataSet();

    let isSameDay = false;

    if (this.range?.dateStart && this.range?.dateStart) {
      isSameDay = this.moment(this.moment(this.range.dateStart).format("MM/DD/YYYY")).isSame(this.moment(this.range.dateEnd).format("MM/DD/YYYY"))
    }

    // Set Options
    this.options = {
      groupOrder: (a, b) => {
        return a.order - b.order;
      },
      groupOrderSwap: (groupDragged, groupToSwap) => {
        const value = groupDragged.order;
        groupDragged.order = groupToSwap.order;
        groupToSwap.order = value;
      },
      onMoveGroup: (groupMoved) => {
        this.onMoveGroup({agentId: groupMoved.agentId, index: groupMoved.order})
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }

        const mainContainer = document.createElement('div');
        mainContainer.classList.add("group-container");

        const groupColor = this._getColorByAgentId(group.agentId);
        const colorContainer = document.createElement('div');
        colorContainer.setAttribute('style', `background: ${groupColor}`);
        colorContainer.classList.add("group-color-container");
        if (group.id) {
          colorContainer.dataset.bzAction = 'agent-color';
          colorContainer.dataset.bzId = String(group.id);
        }

        const actionsContainer = document.createElement('div');
        actionsContainer.classList.add("group-actions-container");

        const starIcon = _.includes(this.favouriteAgentIds || [], group.id) ?
          this.$fullStarIcon.cloneNode(true) :
          this.$emptyStarIcon.cloneNode(true);
        starIcon.classList.add("group-icon");
        if (group.id) {
          starIcon.dataset.bzAction = 'toggle-favourite-agent';
          starIcon.dataset.bzId = String(group.id);
        }

        const chatIcon = this.$chatIcon.cloneNode(true)
        chatIcon.classList.add("group-icon");

        actionsContainer.insertAdjacentElement('beforeend', chatIcon);
        actionsContainer.insertAdjacentElement('beforeend', starIcon);

        const infoContainer = document.createElement('div');
        infoContainer.classList.add("group-info-container");


        // Agent Name / Skills Row

        // Agent Name
        const nameRow = document.createElement('div');
        nameRow.classList.add("group-info-row");

        const groupNameSpan = document.createElement('a');
        groupNameSpan.classList.add("agent-name", "text-ellipsis", "br-body-2", "font-weight-600");
        groupNameSpan.innerText = group.name;
        if (group.agentId) {
          groupNameSpan.dataset.bzAction = 'view-agent-schedule';
          groupNameSpan.dataset.bzId = String(group.agentId);
        }

        nameRow.insertAdjacentElement('beforeend', groupNameSpan);

        const agentStatusDiv = document.createElement('div');
        agentStatusDiv.classList.add("agent-status", group.status);

        nameRow.insertAdjacentElement('beforeend', agentStatusDiv);

        // // Vehicle Type
        // if (this.groupsViewSettings.vehicleType && group.vehicleType) {
        //   const vehicleType = document.createElement('div');
        //   vehicleType.classList.add('skill-tag');
        //
        //   const icon = document.createElement('IMG');
        //   icon.setAttribute("src", this.iconsUrl[group.vehicleType]);
        //   this.$routedWhiteIcon.classList.add('bringoz-icon-small', 'white');
        //   icon.classList.add("bringoz-icon-small", "margin-top-0", "margin-bottom-0", "margin-left-0");
        //   vehicleType.insertAdjacentElement('beforeend', icon);
        //
        //   const employmentTypeText = document.createElement('span')
        //   employmentTypeText.innerHTML = this.$filter('translate')(group.vehicleType);
        //   vehicleType.appendChild(employmentTypeText);
        //   nameRow.insertAdjacentElement('beforeend', vehicleType);
        // }

        // // Employment Type
        // if (this.groupsViewSettings.employmentType && group.employmentType) {
        //   const employmentType = document.createElement('div');
        //   employmentType.classList.add('skill-tag');
        //
        //   const icon = this.$employmentTypeIcon.cloneNode(true);
        //   icon.classList.add("margin-top-0", "margin-bottom-0", "margin-left-0");
        //   employmentType.insertAdjacentElement('beforeend', icon);
        //
        //   const employmentTypeText = document.createElement('span')
        //   employmentTypeText.innerHTML = this.$filter('translate')(group.employmentType);
        //   employmentType.appendChild(employmentTypeText);
        //   nameRow.insertAdjacentElement('beforeend', employmentType);
        // }

        // // Skills
        // if (this.groupsViewSettings.skills && group.skills?.length) {
        //   group.skills.forEach((s) => {
        //     const skill = document.createElement('div');
        //     skill.classList.add('skill-tag');
        //
        //     const icon = this.$skillsIcon.cloneNode(true);
        //     icon.classList.add("margin-top-0", "margin-bottom-0", "margin-left-0");
        //     skill.insertAdjacentElement('beforeend', icon);
        //
        //     const skillText = document.createElement('span')
        //     skillText.innerHTML = s;
        //     skill.appendChild(skillText);
        //     nameRow.insertAdjacentElement('beforeend', skill);
        //   })
        // }

        // Vehicle Type Row
        // let vehicleTypeRow;
        // if (this.groupsViewSettings.vehicleType) {
        //
        //   vehicleTypeRow = document.createElement('div');
        //   const icon = document.createElement('IMG');
        //   icon.setAttribute("src", this.iconsUrl[group.vehicleType]);
        //   icon.classList.add("bringoz-icon-small", "gray", "group-icon");
        //   this.$branchIcon.classList.add('bringoz-icon-small', 'gray')
        //   vehicleTypeRow.insertAdjacentElement('beforeend', icon);
        //
        //   vehicleTypeRow.classList.add("group-info-row");
        //   const vehicleTypeSpan = document.createElement('span');
        //   vehicleTypeSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
        //   vehicleTypeSpan.innerHTML = this.$filter('translate')(group.vehicleType);
        //   vehicleTypeRow.insertAdjacentElement('beforeend', vehicleTypeSpan);
        // }


        // Tags Row
        let tagsRow;
        if (this.groupsViewSettings.tags) {
          tagsRow = document.createElement('div');
          tagsRow.classList.add("group-info-row");

          const icon = document.createElement('IMG');
          icon.setAttribute("src", this.iconsUrl.tags);
          icon.classList.add("bringoz-icon-small", "gray", "group-icon");
          tagsRow.insertAdjacentElement('beforeend', icon);

          if (!group.tags?.length) {
            const text = document.createElement('span')
            text.textContent = '---';
            tagsRow.insertAdjacentElement('beforeend', text);
          }

          group.tags?.forEach((t) => {
            const tag = document.createElement('div');
            tag.classList.add('tag-container');

            const text = document.createElement('span')
            text.textContent = t;
            tag.appendChild(text);
            tagsRow.insertAdjacentElement('beforeend', tag);
          })
        }

        // Service Areas Row
        let serviceAreasRow;
        if (this.groupsViewSettings.serviceAreas) {

          serviceAreasRow = document.createElement('div');

          const icon = this.$serviceAreaIcon.cloneNode(true);
          icon.classList.add("group-icon");
          serviceAreasRow.insertAdjacentElement('beforeend', icon);
          serviceAreasRow.classList.add("group-info-row");

          if (group.priorityServiceAreas?.length) {
            const serviceAreasSpan = document.createElement('span');
            serviceAreasSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            serviceAreasSpan.innerText = group.priorityServiceAreas[0].areaName;

            serviceAreasRow.insertAdjacentElement('beforeend', serviceAreasSpan);

            if (group.priorityServiceAreas.length > 1) {
              const extraServiceAreasSpan = document.createElement('span');
              extraServiceAreasSpan.classList.add("extra-count", "text-ellipsis", "br-caption-2", "font-weight-500", "color-primary-100");
              extraServiceAreasSpan.textContent = `+${group.priorityServiceAreas.length - 1}`
              serviceAreasRow.insertAdjacentElement('beforeend', extraServiceAreasSpan);
            }
          } else {
            const allSpan = document.createElement('span');
            allSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            allSpan.textContent = this.$filter('translate')('All');
            serviceAreasRow.insertAdjacentElement('beforeend', allSpan);
          }
        }


        // Branches Row
        let branchesRow;
        if (this.groupsViewSettings.branches) {

          branchesRow = document.createElement('div');

          const icon = this.$branchIcon.cloneNode(true);
          icon.classList.add("group-icon");
          branchesRow.insertAdjacentElement('beforeend', icon);

          if (group.branchReferences?.length) {
            branchesRow.classList.add("group-info-row");
            const branchesSpan = document.createElement('span');
            branchesSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            branchesSpan.innerText = group.branchReferences[0].name;

            branchesRow.insertAdjacentElement('beforeend', branchesSpan);

            if (group.branchReferences.length > 1) {
              const extraBranchesSpan = document.createElement('span');
              extraBranchesSpan.classList.add("extra-count", "text-ellipsis", "br-caption-2", "font-weight-500", "color-primary-100");
              extraBranchesSpan.textContent = `+${group.branchReferences.length - 1}`
              branchesRow.insertAdjacentElement('beforeend', extraBranchesSpan);
            }
          } else {
            const allSpan = document.createElement('span');
            allSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            allSpan.textContent = this.$filter('translate')('All');
            branchesRow.insertAdjacentElement('beforeend', allSpan);
          }
        }

        infoContainer.insertAdjacentElement('beforeend', nameRow);

        // if (vehicleTypeRow) {
        //   infoContainer.insertAdjacentElement('beforeend', vehicleTypeRow.cloneNode(true));
        // }
        if (tagsRow) {
          infoContainer.insertAdjacentElement('beforeend', tagsRow.cloneNode(true));
        }
        if (serviceAreasRow) {
          infoContainer.insertAdjacentElement('beforeend', serviceAreasRow.cloneNode(true));
        }
        if (branchesRow) {
          infoContainer.insertAdjacentElement('beforeend', branchesRow.cloneNode(true));
        }

        mainContainer.insertAdjacentElement('beforeend', colorContainer);
        mainContainer.insertAdjacentElement('beforeend', actionsContainer);
        mainContainer.insertAdjacentElement('beforeend', infoContainer);

        return mainContainer;
      },
      onMove: (item, callback) => {
        const shift = angular.copy(item.ref);
        shift.agentSchedule.schedule.startTime = item.start.valueOf();
        shift.agentSchedule.schedule.endTime = item.end.valueOf();
        this.onUpdateShift({shift: shift, updateSpecificDay: true, callback: callback})
        // this.onMoveItem(
        //   {
        //     serviceIds: serviceIds,
        //     fromRouteId: fromRouteId,
        //     toRouteId: toRouteId,
        //     fromOrderedIds: fromOrderedIds,
        //     toOrderedIds: toOrderedIds,
        //     scheduleInstanceId: _.get(schedulesIds, 'length') ? schedulesIds[0] : undefined,
        //     originalId: _.get(schedulesItems, '[0].ref.agentSchedule.id'),
        //     // originalId: isRecurring ? _.get(schedulesItems, '[0].ref.agentSchedule.id') : undefined,
        //     agentId: _.get(schedulesItems, 'length') ? schedulesItems[0].group : undefined,
        //     isBetweenDays: isBetweenDays,
        //     toDate: item.start,
        //     item: item,
        //     assignServices: !isBetweenRoutes ? undefined : (isUnassigned ? undefined : payload[0].enabled),
        //     resetServices: !isBetweenRoutes ? undefined : (isUnassigned ? payload[0].enabled : undefined),
        //     callback: callback
        //   })


      },
      snap: function (date, scale, step) {
        var time = 900000; // 15 mins
        return Math.round(date / time) * time;
      },
      // editable: true,
      selectable: true,
      multiselect: true,
      multiselectPerGroup: true,
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: !this.isLoading,                   // drag items horizontally
        updateGroup: false,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: this.isLoading          // allow these options to override item.editable
      },
      showTooltips: !!this.isTooltipsEnabled,
      tooltip: {
        followMouse: true
      },
      // verticalScroll: true,
      // tooltipOnItemUpdateTime: {
      //   template: function(item) {
      //     // Option to add tooltip when dragging item (useful)
      //     return 'html template for tooltip with <b>item.start</b>: ' + item.start;
      //   }
      // },
      orientation: "top",
      verticalScroll: true,
      zoomKey: "ctrlKey",
      groupEditable: true,
      width: '100%',
      // height: '100%',
      margin: {
        item: {horizontal: 0, vertical: 0},
        axis: 5
      },
      stack: true,
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          millisecond: this.timeFormat,
          second: this.timeFormat,
          weekday: 'ddd ' + this.shortDateFormat,
          day: 'ddd ' + this.shortDateFormat,
          week: 'ddd ' + this.shortDateFormat,
          month: this.shortDateFormat,
          year: this.longDateFormat
        },
        majorLabels: {
          millisecond: 'ddd ' + this.shortDateFormat,
          second: 'ddd ' + this.shortDateFormat,
          minute: 'ddd ' + this.shortDateFormat,
          hour: 'ddd ' + this.shortDateFormat,
          weekday: '',
          day: 'ddd ' + this.shortDateFormat,
          week: '',
          month: '',
          year: ''
        }
      },
      start: this.range.dateStart ? this.moment(this.range.dateStart).subtract(1, 'hour') : this.moment().startOf('day'),
      end: this.range.dateEnd ? this.moment(this.range.dateEnd).add(1, 'hour') : this.moment().endOf('day'),
      min: this.range.min ? this.moment(this.range.min) : (this.range.dateStart ? this.moment(this.range.dateStart) : this.moment().startOf('day')),
      max: this.range.max ? this.moment(this.range.max) : (this.range.dateEnd ? this.moment(this.range.dateEnd) : this.moment().endOf('day')),
      // zoomable: false,
      moveable: true
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Set Table Actions
    this.topElementRef = this.timeline.body.dom.top;
    this.topElementRef.style = 'left: 0px';

    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("resources-list-header-container");

    this.topElementRef.before(this.tableHeaderDivRef);

    // Init Timeline
    if (this.agents?.length) {

      // Init Agents Groups
      this.groupsDataSet.add(this._getGroupsData(this.agents));

      // Add Schedule Items
      if (this.schedules?.length) {
        this.itemsDataSet.add(this._getScheduleItemsData(this.schedules));
        this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.schedules));
      }
    }

    // DoubleClick Event
    this.timeline.on('doubleClick', (properties) => {
      this._onClicked().then(() => {

        if (properties.what === 'axis') {
          this.onAxisClick({date: this.moment(properties.time).valueOf()})
          return;
        }

        // Item Click
        if (properties.what === 'item') {
          const item = this.itemsDataSet.get(properties.item);

          // Schedule Click
          if (item.itemType === 'SCHEDULE') {

            // // Leave
            // if (item.itemSubType === ScheduleType.Leave) {
            //   return;
            // }

            const agentRef = _.find(this.agents, (a) => {
              return a.id === item.agentId
            });

            // Availability
            if (item.itemSubType === ScheduleType.Availability) {
              this.onCreateSchedule({agent: agentRef, startDate: item.start.valueOf(), endDate: item.end.valueOf()});
            }

            // Shift
            if (item.itemSubType === ScheduleType.Shift || item.itemSubType === ScheduleType.Leave) {
              this.onScheduleSelect({
                schedule: item.ref,
                date: item.start.valueOf(),
                agent: agentRef
              });
            }

          }

          // Breaks Click
          if (item.itemType === 'BREAK') {
            const scheduleRef = this.schedules.find((s) => {
              return s.id === item.scheduleId;
            })
            const agentRef = _.find(this.agents, (a) => {
              return a.id === item.agentId
            });
            this.onScheduleSelect({
              schedule: scheduleRef,
              date: item.start.valueOf(),
              agent: agentRef
            });
          }

        }

        let startDate;
        let endDate;
        if (properties.group && !_.get(properties, 'item')) {
          const agent = _.find(this.agents, (a) => {
            return a.id === properties.group
          });
          if (agent) {
            let selectedDate = undefined;
            if (_.isEqual(_.get(properties, 'what'), 'background') && _.get(properties, 'time')) {
              selectedDate = (properties.time).getTime();
              startDate = this.moment(selectedDate).startOf('day').valueOf()
              endDate = this.moment(selectedDate).endOf('day').minute(45).seconds(0).millisecond(0).valueOf();
            }
            this.onCreateSchedule({agent: agent, startDate: startDate, endDate: endDate});
          }
        }
      })
      properties.event.preventDefault();
    });

    this.timeline.itemSet.groupHammer.off('tap');

    // Select Event
    this.timeline.on('select', (properties) => {
      properties.event.preventDefault();
      this._onClicked().then(() => {
        const selectedItemIds = this.timeline.getSelection();

        const highlightedSchedules = [];

        _.forEach(selectedItemIds, (itemId) => {
          const selectedItem = this.itemsDataSet.get(itemId);

          const agent = _.find(this.agents, (a) => {
            return a.id === selectedItem.ref.agentId;
          })

          if (selectedItem.itemType === 'SCHEDULE') {
            const item = {
              id: selectedItem.id,
              schedule: selectedItem.ref,
              date: selectedItem.start.valueOf(),
              agent: agent
            }
            highlightedSchedules.push(item)
          }

        })

        this.onHighlightedItemsChange({highlightedSchedules: highlightedSchedules});
        properties.event.preventDefault();
      });
    });

    // Right Click Event
    this.timeline.on('contextmenu', (properties) => {
      if (_.get(properties, 'item')) {
        const item = this.itemsDataSet.get(properties.item);
        const event = properties.event;

        if (item.itemType === 'SCHEDULE') {

          // Availability
          if (item.itemSubType === ScheduleType.Availability) {
            this.onRightClickAvailability({scheduleItem: item, event: event});
            properties.event.preventDefault();
            return;
          }

          // Leave
          if (item.itemSubType === ScheduleType.Leave) {
            this.onRightClickLeave({scheduleItem: item, event: event});
            properties.event.preventDefault();
            return;
          }

          // Leave
          if (item.itemSubType === ScheduleType.Shift) {
            this.onRightClickSchedule({scheduleItem: item, event: event});
            properties.event.preventDefault();
            return;
          }

        }

        properties.event.preventDefault();
      }
    });

    // Hover
    this.timeline.on('mouseOver', (props) => {
      if (props.item) {
        this._onClicked().then(() => {

        });
      }
    });

  };

  $onChanges(changes: angular.IOnChangesObject) {

    if ((changes.highlightedSchedules && !changes.highlightedSchedules.isFirstChange())) {
      this.$timeout().then(() => {
        const highlightedScheduleIds = _.map(this.highlightedSchedules, 'id');

        this.timeline.setSelection(highlightedScheduleIds);
      })
    }

    if (changes.agents && !changes.agents.isFirstChange()) {
      const currentAgents = changes.agents.currentValue || [];
      const previousAgents = changes.agents.previousValue || [];

      const agentsToAdd = _.differenceBy(currentAgents, previousAgents, 'id');
      const agentsToRemove = _.differenceBy(previousAgents, currentAgents, 'id');


      const currentUpdatedAgents = _.differenceBy(currentAgents, agentsToAdd, 'id');
      const previousUpdatedAgents: any = _.differenceBy(previousAgents, agentsToRemove, 'id');

      const currentAgentsToUpdate = _.filter(currentUpdatedAgents, (currentUpdatedAgent: any) => {
        const previousUpdatedAgent = _.find(previousUpdatedAgents, ['id', currentUpdatedAgent.id]);
        // Check if agent was changed
        return previousUpdatedAgent.updatedAt < currentUpdatedAgent.updatedAt;
      });

      // Remove
      if (agentsToRemove.length) {
        this.groupsDataSet.remove(_.map(agentsToRemove, 'id'));
      }


      // Update
      if (!!currentAgentsToUpdate.length) {
        const currentAgentsIdsToUpdate = _.map(currentAgentsToUpdate, 'id');
        const updatedGroups = this._getGroupsData(currentAgentsToUpdate);
        this.groupsDataSet.update(updatedGroups);
      }

      // Add
      if (agentsToAdd.length) {
        this.groupsDataSet.add(this._getGroupsData(agentsToAdd));
      }

      // OLD
      // this.groupsDataSet.clear();
      // this.groupsDataSet.add(this._getGroupsData(this.agents));

      this.options.height = _.get(this.agents, 'length', 0) === 0 ? '100%' : null
      this.timeline.setOptions(this.options);
    }

    if (changes.schedules && !changes.schedules.isFirstChange()) {
      this._clearScheduleItems();
      this.itemsDataSet.add(this._getScheduleItemsData(this.schedules));
      this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.schedules));
      // timeline.fit();
    }

    if (changes.favouriteAgentIds && !changes.favouriteAgentIds.isFirstChange()) {
      this.$timeout(0).then(() => {
        const updatedGroups = [];

        this.groupsDataSet.forEach((group) => {
          updatedGroups.push(group);
        });

        this.groupsDataSet.update(updatedGroups);
      })
    }

    if (changes.range && !changes.range.isFirstChange()) {
      this.options.start = this.range.min ? this.moment(this.range.min) : (this.moment(this.range.dateStart) ? this.moment(this.range.dateStart).subtract(1, 'hour') : this.moment().startOf('day'));
      this.options.end = this.range.max ? this.moment(this.range.max) : (this.moment(this.range.dateEnd) ? this.moment(this.range.dateEnd).add(1, 'hour') : this.moment().endOf('day'));
      this.options.min = this.range.min ? this.moment(this.range.min) : this.moment(this.range.dateStart);
      this.options.max = this.range.max ? this.moment(this.range.max) : this.moment(this.range.dateEnd);

      this.timeline.setOptions(this.options);
      this.timeline.setWindow(new Date(this.range.dateStart), new Date(this.range.dateEnd));
    }

    if (changes.isTooltipsEnabled && !changes.isTooltipsEnabled.isFirstChange()) {
      this.options.showTooltips = !!this.isTooltipsEnabled;
      this.timeline.setOptions(this.options);
    }

    if (changes.isLoading && !changes.isLoading.isFirstChange()) {
      // this.options.editable.overrideItems = this.isLoading;
      this.options.editable = {
        add: false,
        updateTime: !this.isLoading,
        updateGroup: !this.isLoading,
        remove: false,
        overrideItems: true
      };
      this.timeline.setOptions(this.options);
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  onFit() {
    this.timeline.fit();
  }

  onGroupsViewSettingsChange(updatedGroupsViewSettings) {
    this.groupsViewSettings = updatedGroupsViewSettings;
    this.redrawGroupTemplate();
  }


  // ******************************
  //        Private methods
  // ******************************

  _getGroupsData(agents) {


    const agentsGroups = [];

    _.forEach(agents, (a, index) => {
      agentsGroups.push(this._getAgentsGroup(a, index));
    })

    return agentsGroups;
  }

  private _getTranslatedSkills(skills, isFirstLetterOnly?) {

    return _.map(skills, (s) => {
      let text;

      if(this.siteSkills[s].custom) {
        text = this.siteSkills[s].name;
      } else {
        text = this.$filter('translate')('SKILLS.' + this.siteSkills[s].name);
      }
      return isFirstLetterOnly ? text.charAt(0) : text;
    });
  }

  private _getScheduleBreaksItemsData(schedules) {
    let items = [];

    _.forEach(schedules, (s) => {
      _.forEach(s.scheduleExtraData, (extraData) => {
        _.forEach(extraData.breaks, (b) => {
          const exceptions = _.get(s, 'agentSchedule.schedule.exceptions', []);

          if (exceptions.length) {
            const isException = _.find(exceptions, (e) => {
              return this.moment(extraData.eventDate).isSame(this.moment(e), 'date');
            })
            if (isException) {
              return;
            }
          }
          items.push(this._getScheduleBreakItemData(b, s.agentId, s.id)) //AgentScheduleBreak
        })
      })
    });

    return items;
  }

  private _getScheduleItemsData(schedules) {
    let items = [];
    const monthInMili = 2592000000;


    _.forEach(schedules, (item) => {

      const scheduleRecurringString = _.get(item, 'agentSchedule.schedule.rrule', '');

      if (scheduleRecurringString) {
        const ruleOptions = this.rrule.RRule.parseString(scheduleRecurringString);

        ruleOptions.dtstart = this.moment(item.agentSchedule.schedule.startRecurring).utc(true).toDate()
        if (item.agentSchedule.schedule.endRecurring) {
          ruleOptions.until = this.moment(item.agentSchedule.schedule.endRecurring).utc(true).toDate();
        }

        const rule = new this.rrule.RRule(ruleOptions);
        let dates = rule.between(new Date(this.range.dateStart - monthInMili), new Date(this.range.dateEnd + monthInMili));

        // convert to local
        dates = _.map(dates, (d) => {
          return this.moment(d).set({
            year: this.moment.utc(d).year(),
            month: this.moment.utc(d).month(),
            date: this.moment.utc(d).date()
          }).startOf('day').toDate();
        })

        const exceptions = _.get(item, 'agentSchedule.schedule.exceptions', []);


        items = items.concat(
          this._parseReacquiringItemsByType(item, dates, exceptions) //AgentSchedule
        );
      } else {
        items.push(this._parseAgentScheduleToItem(item));
      }
    });

    return items;
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private redrawGroupTemplate() {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.priorityServiceAreas = this._getServiceAreasByIds(group.priorityServiceAreasIds || []);
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
    // timeline.setGroups(updatedGroups);
  }

  private _clearScheduleItems() {
    const itemsToClear = [];
    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'SCHEDULE' || item.itemType === 'BREAK') {
        itemsToClear.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToClear);
  }

  private _getColorByAgentId(id) {
    const agent: AgentModel = _.find(this.agents, (a: AgentModel) => {
      return a.id === id;
    })
    return agent?.displayColor || this.commonsService.getColorById(id, this.colorPallet);
  }

  // private _getColorByAgentId(id) {
  //
  //   const agentIndex = _.findIndex(this.agents, (a: AgentModel) => {
  //     return a.id === id;
  //   })
  //
  //   if (agentIndex > -1) {
  //     return this.agents[agentIndex].displayColor || this.colorPallet[agentIndex];
  //   } else {
  //     const randomIndex = Math.floor(Math.random() * this.agents.length);
  //     return this.colorPallet[randomIndex];
  //   }
  // }

  private _getAgentsGroup(a, index) {
    const isEven = (index % 2) === 0;
    let className = 'group-row br-caption-2';
    className += !!isEven ? ' even' : ' odd';
    className += ' agent-left-container';

    return {
      id: a.id,
      agentId: a.id,
      name: this.$filter('userName')(a.user),
      nameInitials: this.$filter('userInitials')(a.user),
      agentType: this.$filter('translate')(_.get(a, 'agentType', '')),
      skills: this._getTranslatedSkills(a.skills),
      tags: a.tags || [],
      requiredSkills: a.skills,
      vehicleType: a.vehicleType,
      branchReferences: _.get(a, 'branchReferences'),
      employmentType: this.$filter('translate')(a.employmentType),
      priorityServiceAreas: this._getServiceAreasByIds(_.get(a, 'agentPreferencesReference.priorityServiceAreas', [])),
      priorityServiceAreasIds: _.get(a, 'agentPreferencesReference.priorityServiceAreas', []),
      status: a.status,
      className: className,
      taskCount: _.get(a, 'itineraryInfo.numberOfTasks', 0),
      ref: a,
      order: index,
      showNested: true
    }
  }

  private _parseAgentScheduleToItem(item) {
    const color = this._getColorByAgentId(item.agentId);
    const canEdit = !this.isLoading && (item.agentSchedule.type !== ScheduleType.Availability ? this.isSuperOwner : true);


    return {
      itemType: 'SCHEDULE',
      itemSubType: item.agentSchedule.type,
      start: this.moment(item.agentSchedule.schedule.startTime),
      end: this.moment(item.agentSchedule.schedule.endTime),
      id: item.agentSchedule.id + ':Tag:' + item.agentId + ':Date:' + this.moment(item.agentSchedule.schedule.startTime).format("DD-MM-YYYY"),
      group: item.agentId,
      agentId: item.agentId,
      ref: item,
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: canEdit,                   // drag items horizontally
        updateGroup: false,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: canEdit          // allow these options to override item.editable
      },
      selectable: true,
      title: this.bringozTimelineService.getShiftTimelineItemTooltip(item, undefined, this.serviceAreas),
      content: this.bringozTimelineService.getShiftContentNew(item, item.agentSchedule.schedule.startTime, item.agentSchedule.schedule.endTime),
      className: `${item.agentSchedule.type}`,
      // type: 'background',
      style: 'color: black; background: ' + color
    }
  }

  private _parseReacquiringItemsByType(item, dates, exceptions) {
    const color = this._getColorByAgentId(item.agentId);

    if (exceptions.length) {
      dates = _.filter(dates, (d) => {
        const exception = _.find(exceptions, (e) => {
          return this.moment(d).isSame(this.moment(e), 'date');
        });
        return _.isUndefined(exception);
      });
    }
    return _.map(dates, (date) => {
      const dateToDifferenceInMili = this.moment(item.agentSchedule.schedule.endTime).diff(this.moment(item.agentSchedule.schedule.startTime));
      const dateFrom = this.moment(date).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date(),
        hour: this.moment(item.agentSchedule.schedule.startTime).hours(),
        minute: this.moment(item.agentSchedule.schedule.startTime).minutes(),
        second: this.moment(item.agentSchedule.schedule.startTime).seconds()
      });
      const dateTo = this.moment(dateFrom.valueOf() + dateToDifferenceInMili);
      return {
        // id: moment(date).valueOf() + '-' + item.agentSchedule.id, //AgentSchedule
        id: item.agentSchedule.id + ':Tag:' + item.agentId + ':Date:' + this.moment(date).format("DD-MM-YYYY"),
        itemType: 'SCHEDULE',
        itemSubType: item.agentSchedule.type,
        scheduleId: item.agentSchedule.id,
        start: this.moment(dateFrom),
        end: this.moment(dateTo),
        startTime: dateFrom,
        endTime: dateTo,
        group: item.agentId,
        agentId: item.agentId,
        ref: item,
        editable: false,
        title: this.bringozTimelineService.getShiftTimelineItemTooltip(item, undefined, this.serviceAreas),
        // content: this.bringozTimelineService.getShiftContent(item, dateFrom, dateTo, true),
        className: `${item.agentSchedule.type}`,
        // type: 'background',
        style: 'background: ' + color
      }
    })
  }

  private _getScheduleBreakItemData(breakData, agentId, scheduleId) {
    return {
      // id: moment(date).valueOf() + '-' + item.agentSchedule.id, //AgentSchedule
      id: breakData.id,
      itemType: 'BREAK',
      start: this.moment(breakData.notBefore),
      end: this.moment(breakData.endDate ? breakData.endDate : (breakData.notBefore + breakData.duration)),
      startTime: breakData.notBefore,
      endTime: breakData.notAfter,
      group: agentId,
      agentId: agentId,
      ref: breakData,
      scheduleId: scheduleId,
      editable: false,
      // title: this.bringozTimelineService.getShiftTimelineItemTooltip(item, date, true, this.serviceAreas),
      // content: this.bringozTimelineService.getShiftContent(item, dateFrom, dateTo, true),
      className: 'break',
      selectable: false
    }
  }

  private _getServiceAreasByIds(ids) {
    const serviceAreas = this.serviceAreas || [];
    return serviceAreas.length ? serviceAreas.filter((area) => {
      return ids.includes(area.id);
    }) : [];
  }

  private _setMinorLabels(date: any, scale: number, step: number) {
    const isSameDay = this.moment(this.moment(this.range.dateStart).format("MM/DD/YYYY")).isSame(this.moment(this.range.dateEnd).format("MM/DD/YYYY"));

    if (!!isSameDay) {
      // const dateRef = angular.copy( this.moment(date).startOf('day'));
      const index = this._getDateIntervalIndex(date, step);

      const totals = _.find(this.totals, (t) => {
        return this.moment(this.moment(t.date).format("MM/DD/YYYY")).isSame(this.moment(date).format("MM/DD/YYYY"));
      }) || {};

      const planned = _.get(totals, `plannedAgentsPerInterval[${index}]`, 0) || 0;
      const prediction = _.get(totals, `predictedAgentsPerInterval[${index}]`, 0) || 0;

      const plannedTest = _.get(totals, `plannedAgentsPerIntervalMap[${date.valueOf()}]`, 0) || 0;
      const predictionTest = _.get(totals, `predictedAgentsPerIntervalMap[${date.valueOf()}]`, 0) || 0;

      const calcPredication = plannedTest - predictionTest;
      const calcClass = this._getCalcClass(calcPredication);

      return `<div class="label-container"><span>${date.format('HH:mm')}</span><span class="total">${plannedTest}</span><span class="${calcClass}">${calcPredication}</span></div>`
    } else {

      const container = document.createElement('div');
      container.classList.add("main-container");

      const mainDiv = document.createElement('div');
      mainDiv.classList.add("labels-container");

      const totals = _.find(this.totals, (t: any) => {
        return this.moment(this.moment(t.date).format("MM/DD/YYYY")).isSame(this.moment(date).format("MM/DD/YYYY"))
      })

      _.times(totals?.resolution || 0, (i) => {
        const stepDiv = document.createElement('div');

        const planned = _.get(totals, `plannedAgentsPerInterval[${i}]`, 0) || 0;
        const prediction = _.get(totals, `predictedAgentsPerInterval[${i}]`, 0) || 0;

        const plannedTest = _.get(totals, `plannedAgentsPerIntervalMap[${angular.copy(this.moment(date).startOf('day')).add(totals.intervalMinutes * i, 'minute').valueOf()}]`, 0) || 0;
        const predictionTest = _.get(totals, `predictedAgentsPerIntervalMap[${angular.copy(this.moment(date).startOf('day')).add(totals.intervalMinutes * i, 'minute').valueOf()}]`, 0) || 0;

        const calcPredication = plannedTest - predictionTest;
        const calcClass = this._getCalcClass(calcPredication);

        stepDiv.classList.add("week-label-container", calcClass);
        mainDiv.insertAdjacentElement('beforeend', stepDiv);
      })

      const dateSpan = document.createElement('span');
      dateSpan.textContent = date.format(this.dateFormat);

      container.insertAdjacentElement('beforeend', dateSpan);
      container.insertAdjacentElement('beforeend', mainDiv);
      return container.outerHTML;


      // imageDiv.classList.add("label-container");
    }

  }

  private _setMajorLabels(date: any, scale: number, step: number) {
    return '';
  }

  private _getDateIntervalIndex(date, intervalLength) {
    const hour = new Date(date.valueOf()).getHours();
    const minute = new Date(date.valueOf()).getMinutes();

    const totalMinutes = minute + (hour * 60);
    return totalMinutes / intervalLength;
  }

  private _getCalcClass(calcPredication) {
    let className

    if (calcPredication >= 15) {
      className = 'level4';
    } else if (calcPredication < 15 && calcPredication >= 10) {
      className = 'level3';
    } else if (calcPredication < 10 && calcPredication >= 5) {
      className = 'level2';
    } else if (calcPredication < 5 && calcPredication >= 0) {
      className = 'level1';
    } else if (calcPredication === 0) {
      className = 'level0';
    } else if (calcPredication < 0 && calcPredication >= -5) {
      className = 'level-1';
    } else if (calcPredication < -5 && calcPredication >= -10) {
      className = 'level-2';
    } else if (calcPredication < -10 && calcPredication >= -15) {
      className = 'level-3';
    } else if (calcPredication <= -15) {
      className = 'level-4';
    } else {
      className = 'level0';
    }

    return className;
  }

  $onDestroy() {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsShiftManagementTimelineNew', {
    bindings: {
      agents: '<',
      schedules: '<',
      serviceAreas: '<',
      totals: '<?',
      range: '<',
      query: '<',
      isLoading: '<',
      sortType: '<',
      isTooltipsEnabled: '<',
      agentsGroup: '<',
      highlightedSchedules: '<?',
      isFavouriteAgentsMode: '<?',
      favouriteAgentIds: '<?',
      onScheduleSelect: '&',
      onViewService: '&',
      onAxisClick: '&',
      onRightClickSchedule: '&',
      onRightClickAvailability: '&',
      onRightClickLeave: '&',
      onCreateSchedule: '&',
      onMoveGroup: '&',
      onDatesPageChange: '&',
      onAgentsGroupChange: '&',
      onToggleHighlightSchedule: '&',
      onHighlightedItemsChange: '&',
      onAgentColorClick: '&',
      onToggleIsFavouriteAgentsMode: '&',
      onToggleFavouriteAgent: '&',
      onChatClick: '&',
      onUpdateShift: '&',
      onResetFavouriteAgents: '&',
      onSort: '&'
    },
    template: require('./agents-shift-management-timeline-new.html').default,
    controller: AgentsShiftManagementTimelineNewComponent
  });
